import angular from 'angular'
import templateUrl from './edit-division-profile.component.html'
import { AdjustDivisionRotationsModal } from '../adjust-rotations-form/adjust-division-rotations-modal.component';
import { EditDivisionProfilePayrollPolicyHistoryModal } from '../edit-division-profile-payroll-policy-history/edit-division-profile-payroll-policy-history-modal.component';

export const EditDivisionProfileComponent = {
    controller: EditDivisionProfileController,
    controllerAs: "vm",
    require: {
        // Integrate with form validation.
        editForm: "?^^form"
    },
    bindings: {
        division: "<",
        divisionProfile: "<",
        countries: "<",
        rotationLengthTypes: "<",
        payrollTypes: "<",
        payrollInvoicePolicies: "<",
        changeDivisionProfile: "&"
    },
    templateUrl
}

function EditDivisionProfileController($uibModal) {
    'ngInject'
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const vm = this;

    vm.$onInit = onInit;
    vm.editForm;
    vm.division;
    vm.divisionProfile;
    vm.expanded;
    vm.lockStartDate;
    vm.minRotationEndDate = minRotationEndDate;
    vm.maxRotationStartDate = maxRotationStartDate;
    vm.onChange = onChange;
    vm.onAdjustDivisionRotations = onAdjustDivisionRotations;
    vm.onEditPayrollPolicyHistory = onEditPayrollPolicyHistory;
    vm.payrollTypes;
    vm.payrollInvoicePolicies;
    vm.rotationLengthTypes;
    vm.today = new Date();

    function onInit() {
        // Lock the start date if the division profile has been saved,
        // the next rotation end date ends before today, and
        // a new next start date doesn't need to be filled in.
        vm.lockStartDate = vm.divisionProfile.DivisionID
            && vm.divisionProfile.NextRotation
            && vm.divisionProfile.NextRotation.EndDate <= vm.today
            && vm.divisionProfile.NextRotation.StartDate;

        // Expand unsaved divisions by default.
        vm.expanded = !vm.divisionProfile.DivisionProfileID;
    }

    function onAdjustDivisionRotations(divisionProfile) {
        $uibModal.open({
            ...AdjustDivisionRotationsModal,
            resolve: {
                divisionProfile: function () {
                    return divisionProfile;
                }
            }
        });
    }

    function onEditPayrollPolicyHistory(divisionProfile) {
        $uibModal.open({
            ...EditDivisionProfilePayrollPolicyHistoryModal,
            resolve: {
                divisionProfile: function () {
                    // Create a clone of the payroll policy history to be edited in the modal.
                    return {
                        DivisionProfileID: divisionProfile.DivisionProfileID,
                        Name: divisionProfile.Name,
                        PayrollPolicyHistory: angular.copy(divisionProfile.PayrollPolicyHistory)
                    };
                }
            }
        }).result.then(function (payrollPolicyHistory) {
            divisionProfile.PayrollPolicyHistory = payrollPolicyHistory;
        }, () => {});
    }

    function onChange() {
        vm.changeDivisionProfile();
        if (vm.editForm) {
            vm.editForm.$setDirty(true);
        }
    }

    function maxRotationStartDate(rotation) {
        return vm.divisionProfile.NextRotation && vm.divisionProfile.NextRotation.EndDate
            || new Date(9999, 12, 31)
    }

    function minRotationEndDate(rotation) {
        return rotation && rotation.StartDate || new Date(1900, 0, 1);
    }
}
